import React from 'react';
import { instanceProps, ServiceTranslationProps } from '../types';
import { ServiceRecommendationCards } from '../service-recommendation-cards';

type ServiceRecommendationListProps = {
  instanceData: instanceProps[];
  serviceTranslation: ServiceTranslationProps;
  handleModal: () => void;
};

export const ServiceRecommendationList = ({
  instanceData,
  serviceTranslation,
  handleModal
}: ServiceRecommendationListProps) => {
  return instanceData?.map((card: instanceProps) => (
    <React.Fragment key={card.id}>
      <ServiceRecommendationCards
        title={card.title}
        impact={card.impact}
        buttonText={serviceTranslation.buttonText}
        handleModal={handleModal}
        cardInfo={card}
      />
    </React.Fragment>
  ));
};
